import { HubConnection, HubConnectionBuilder, LogLevel } from '@microsoft/signalr';
import { handleRefreshSelectedMLCreatorTable } from '../store/mlcreator-slice/mlcreator';
import { handleRefreshOptimizationsTable } from '../store/optimization-slice/optimization';

class SignalRService {
    private connection: HubConnection | null = null;

    public async startConnection(dispatch: any, token: string): Promise<void> {
        const hubUrl = `${process.env.REACT_APP_API_URL}/notificationHub`;

        this.connection = new HubConnectionBuilder()
            .withUrl(hubUrl, { 
                withCredentials: false,
                headers: {
                    Authorization: `Bearer ${token}`
                } 
            })
            .configureLogging(LogLevel.Information)
            .withAutomaticReconnect()
            .build();

        try {
            await this.connection.start();
            console.log("SignalR Connected.");
            this.setupListeners(dispatch);
        } catch (error) {
            console.error("Error starting SignalR connection: ", error);
        }

        this.connection.onclose((error) => {
            console.log("SignalR Disconnected.", error);
        });
    }

    public async stopConnection(): Promise<void> {
        if (this.connection) {
            await this.connection.stop();
            this.connection = null;
            console.log("SignalR Disconnected.");
        }
    }
    
    private setupListeners(dispatch: any): void {
        if (this.connection) {
            this.connection.on("TrainingUpdate", () => {
                dispatch(handleRefreshSelectedMLCreatorTable()); 
            });

            this.connection.on("OptimisationUpdate", () => {
                dispatch(handleRefreshOptimizationsTable()); 
            });
        }
    }
}

export default new SignalRService();